import { createSlice } from '@reduxjs/toolkit';

export const transactionTypeRequirementSlice = createSlice({
  name: 'transactionTypeRequirement',
  initialState: {
    list: {},
    selected: null
  },
  reducers: {
    setList: (state, action) => {
      
      state.list = action.payload
      state.selected = Object.keys(action.payload || {}).length > 0 ? +Object.values(action.payload)[0].attributes.requirement_id : null
    },
    setSelected: (state, action) => {
      state.selected = +action.payload
    },
  }
})


export const { setList, setSelected } = transactionTypeRequirementSlice.actions;

export default transactionTypeRequirementSlice.reducer;